export const TRIGGER_WORD = 'developers'

export const DEVELOPERS = [
  {
    name: 'song jaeyoung',
    role: 'product owner & backend developer',
  },
  {
    name: 'jeong seongjae',
    role: 'frontend developer',
  },
  {
    name: 'jeong yelim',
    role: 'frontend developer',
  },
  {
    name: 'jo wonik',
    role: 'backend developer',
  },
  {
    name: 'lee dabeen',
    role: 'backend developer',
  },
  {
    name: 'yoon gyeonghan',
    role: 'backend developer',
  },
  {
    name: 'song whoseop',
    role: 'backend developer',
  },
  {
    name: 'hwang yoonha',
    role: 'backend developer',
  },
  {
    name: 'kim jinwoo',
    role: 'product designer',
  },
  {
    name: 'kim jinseon',
    role: 'devops engineer',
  },
  {
    name: 'jeong hyewon',
    role: 'planning & operator',
  },
  {
    name: 'park taehyeon',
    role: 'planning',
  },
  {
    name: 'choi aram',
    role: 'planning',
  },
  {
    name: 'lee hyewon',
    role: 'frontend developer',
  },
]